/**
 * @returns true if price is 0.
 */
export const isFreeVariant = variant => {
  var _variant$pricingStrat;
  return ((_variant$pricingStrat = variant.pricingStrategies) == null || (_variant$pricingStrat = _variant$pricingStrat[0]) == null || (_variant$pricingStrat = _variant$pricingStrat.flatRate) == null ? void 0 : _variant$pricingStrat.amount) === '0';
};
//# sourceMappingURL=is-free-variant.js.map